import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/career-launch/start/page.tsx");
